import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import user from './modules/user'
import label from './modules/label'
import searchForm from './modules/searchForm'
import line from './modules/lineLists'

import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    user,
    label,
    searchForm,
    line
  },
  state: {},
  mutations: {

  },
  actions: {

  },
  getters
})
